import React, { Component } from 'react'
import PropTypes from 'prop-types'


export default class VariableConfiguration extends Component {
    render() {
        return (<div></div>);
    }
}